export const DEFAULT_VALUE = {
  maintainId: "",
  maintainSpareId: "",
  deviceId: "",
  customerCode: "",
  versionMachine: "",
  deviceSpareId: "",
  delivery: "",
  trackingNo: "",
  reasonSpare: "",
};
